import { XIcon } from 'lucide-react';
import { toast } from 'sonner';
import type { ExternalToast } from 'sonner';
import { ReactComponent as ArrowRightIcon } from '@rocco/icons/svg/arrow/arrow-right.svg';

/**
 * The settings to add a close button to a toast. Renders as the standard
 * ghost secondary pill; sonner dismisses the toast on click.
 */
export const TOAST_CLOSE_BUTTON: Readonly<ExternalToast> = {
    cancel: {
        label: (
            <>
                <XIcon className="size-4.5" />
                <span className="sr-only">Dismiss</span>
            </>
        ),
        onClick: () => {},
    },
};

/**
 * A "view the thing this toast reports" action — the island's arrow in a
 * white circle, navigating to `href`. A custom element so sonner's default
 * action-button styling stays off it. Navigates via window.location rather
 * than Remix navigate: these toasts fire right after fetcher actions whose
 * revalidation can swallow a client-side navigation.
 */
export const toastViewAction = (href: string, label: string) => (
    <button
        type="button"
        aria-label={label}
        onClick={() => {
            toast.dismiss();
            window.location.href = href;
        }}
        className="group/view flex size-13.5 shrink-0 items-center justify-center rounded-full bg-white"
    >
        <ArrowRightIcon className="size-4.5 transition-transform duration-200 ease-out group-hover/view:translate-x-0.5" />
    </button>
);
